<template id="app">
  <v-navigation-drawer
    v-model="open"
    :touchless="true"
    fixed
    :clipped="true"
    :width="screenWidth"
    right
    dark
    app
  >
    <v-toolbar flat>
      <img :src="this.$config.tokenIconUrl" width="24" height="24" />
      <v-toolbar-title
        class="ml-2"
        style="font-size:18px;font-weight:500;font-family: sfTextMediumFont;"
        >Token Explorer</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn text tile icon @click="close" class="hidden-lg-and-up">
        <v-icon width="24" height="24">mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-list flat>
      <v-list-item-group v-model="item" color="primary" class="pt-2">
        <!-- :disabled="nameToIndex[key] === item" -->
        <v-list-item
          v-for="(val, key) in menuIcons"
          :key="key"
          @click="redirect(key)"
        >
          <v-list-item-icon class="mr-4">
            <img :src="val" width="24" height="24" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">
              <span style="font-size:16px;font-weight:400;">{{
                menuText[key]
              }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Vue from "vue";
export default {
  data() {
    return {
      item: 0,
      open: false,
      menuIcons: {},
      menuText: {
        general: "General",
        transaction: "Transactions",
        address: "Addresses"
      },
      icons: {
        general: require(`@/assets/common_icon/ic_markets_normal.svg`),
        transaction: require(`@/assets/common_icon/ic_exchange_normal.svg`),
        address: require(`@/assets/common_icon/ic_wallet_normal.svg`)
      },
      iconsActive: {
        general: require(`@/assets/themes/theme_${this.$config.theme}/ic_markets_actived.svg`),
        transaction: require(`@/assets/themes/theme_${this.$config.theme}/ic_exchange_actived.svg`),
        address: require(`@/assets/themes/theme_${this.$config.theme}/ic_wallet_actived.svg`)
      },
      nameToIndex: {
        general: 0,
        transaction: 1,
        transactionDetail: 1,
        address: 2,
        addressDetail: 2,
        error: 0
      },
      pageMap: {
        general: "general",
        transaction: "transaction",
        transactionDetail: "transaction",
        address: "address",
        addressDetail: "address"
      },
      selectedItem: "general",
      screenWidth: window.screen.width,
      defaultDrawerWidth: 256
    };
  },
  watch: {
    $route(toRoute, fromRoute) {
      if (this.nameToIndex[toRoute.name] !== this.nameToIndex[fromRoute.name]) {
        this.setActiveItem();
      }
    },
    theme(val) {
      (this.tokenIcon = require(`@/assets/themes/theme_${val}/logo_color.svg`)),
        (this.iconsActive = {
          general: require(`@/assets/themes/theme_${val}/ic_markets_actived.svg`),
          transaction: require(`@/assets/themes/theme_${val}/ic_exchange_actived.svg`),
          address: require(`@/assets/themes/theme_${val}/ic_wallet_actived.svg`)
        });
      this.setActiveItem();
    }
  },
  computed: {
    ...mapState(["showError", "theme"])
  },
  mounted() {
    let resizeId;
    window.addEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        if (
          this.$vuetify.breakpoint.name === "md" ||
          this.$vuetify.breakpoint.name === "lg" ||
          this.$vuetify.breakpoint.name === "xl"
        ) {
          this.screenWidth = this.defaultDrawerWidth;
        }
      }, 500);
    });
  },
  beforeDestroy() {
    let resizeId;
    window.removeEventListener("resize", () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(() => {
        if (
          this.$vuetify.breakpoint.name === "md" ||
          this.$vuetify.breakpoint.name === "lg" ||
          this.$vuetify.breakpoint.name === "xl"
        ) {
          this.screenWidth = this.defaultDrawerWidth;
        }
      }, 500);
    });
  },
  created() {
    this.setActiveItem();
    // drawer keeps openning when screen size beyond md
    if (
      this.$vuetify.breakpoint.name !== "xs" &&
      this.$vuetify.breakpoint.name !== "sm" &&
      this.$vuetify.breakpoint.name !== "md"
    ) {
      this.open = true;
      this.screenWidth = this.defaultDrawerWidth;
    } else {
      this.screenWidth =
        this.$vuetify.breakpoint.name === "md"
          ? this.defaultDrawerWidth
          : window.screen.width;
    }
  },
  methods: {
    ...mapMutations(["updateErrorMsg", "updateShowError"]),
    redirect(page) {
      // remove error page
      if (this.showError) {
        this.updateShowError(false);
      }
      // change clicked icon to active
      const pageName = this.$router.currentRoute.name;
      if (pageName === page) {
        if (
          this.$vuetify.breakpoint.name === "xs" ||
          this.$vuetify.breakpoint.name === "sm" ||
          this.$vuetify.breakpoint.name === "md"
        ) {
          this.open = false;
        }
        return;
      }
      Vue.set(this.menuIcons, this.selectedItem, this.icons[this.selectedItem]);
      Vue.set(this.menuIcons, page, this.iconsActive[page]);
      this.selectedItem = page;

      if (!this.item && this.item !== 0) {
        this.item = this.nameToIndex[pageName];
      }
      this.$router.push({ name: page });
    },
    openDrawer() {
      if (
        this.$vuetify.breakpoint.name === "xs" ||
        this.$vuetify.breakpoint.name === "sm"
      ) {
        this.screenWidth = window.screen.width;
      } else {
        this.screenWidth = this.defaultDrawerWidth;
      }
      this.open = !this.open;
      this.setActiveItem();
    },
    setActiveItem() {
      this.menuIcons = Object.assign({}, this.menuIcons, this.icons);
      const menuItem = this.pageMap[this.$router.currentRoute.name];
      this.selectedItem = menuItem;
      if (menuItem) {
        this.menuIcons[menuItem] = this.iconsActive[menuItem];
        this.item = this.nameToIndex[menuItem];
      } else {
        this.item = 0;
        Vue.set(this.menuIcons, "general", this.generalIconActive);
        this.selectedItem = "general";
      }
    },
    close() {
      this.open = false;
    }
  }
};
</script>
<style scoped>
@font-face {
  /* font-properties */
  font-family: sfTextMediumFont;
  src: url("../../assets/font/SF-Pro-Text-Medium.ttf");
}
</style>
